import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface ProjectContextType {
  activeTab: string;
  refreshData: () => Promise<void>;
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  const getActiveTab = (path: string): string => {
    if (path.startsWith('/sbom')) return 'sbom';
    if (path.startsWith('/secrets')) return 'secrets';
    if (path.startsWith('/api-security')) return 'api-security';
    return 'dashboard';
  };

  const refreshData = async () => {
    // This will be implemented by components that need refresh functionality
  };

  return (
    <ProjectContext.Provider 
      value={{
        activeTab: getActiveTab(location.pathname),
        refreshData,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};
